export default __webpack_public_path__ + "static/american-progress-3daa113917f25c4291173706b6b5aef0.jpg";